import enUS from './locales/en-US.json'
import frFR from './locales/fr-FR.json'

export const messages: { [key: string]: { [key: string]: string } } = {
  'en-US': enUS,
  'fr-FR': frFR,
}
